import * as firebase from 'firebase';

firebase.initializeApp({
    apiKey: process.env.NODE_ENV === 'development' ? 'AIzaSyDh1W7UO-YEnrsYd3QxUFILdVmztIDDudI' : 'AIzaSyA5bagUr0b7yW_uR9RVk2wxWa5cKV0CaYo',
    authDomain: process.env.NODE_ENV === 'development' ? 'dev-mybaby-bio.firebaseapp.com' : 'mybaby-bio.firebaseapp.com',
    databaseURL: process.env.NODE_ENV === 'development' ? 'https://dev-mybaby-bio.firebaseio.com' : 'https://mybaby-bio.firebaseio.com',
    storageBucket: process.env.NODE_ENV === 'development' ? 'dev-mybaby-bio.appspot.com' : 'mybaby-bio.appspot.com',
});

export default firebase;



/** WEBPACK FOOTER **
 ** ./src/action/firebase.js
 **/